/**
 * Interpreta el texto de búsqueda de contacto para pre-rellenar el modal de creación.
 * - Email → campo email
 * - Teléfono (mayoría dígitos) → campo telefono
 * - Texto con espacios → primera palabra nombre, resto apellidos
 */
export function parseBusquedaContacto(text) {
  const t = String(text || "").trim();
  if (!t) return {};

  if (t.includes("@")) {
    return { email: t };
  }

  const sinEspacios = t.replace(/\s/g, "");
  const digitos = sinEspacios.replace(/\D/g, "");
  if (digitos.length >= 6 && digitos.length / Math.max(sinEspacios.length, 1) >= 0.7) {
    return { telefono: t };
  }

  const partes = t.split(/\s+/).filter(Boolean);
  if (partes.length === 0) return {};
  if (partes.length === 1) return { nombre: partes[0] };
  return { nombre: partes[0], apellidos: partes.slice(1).join(" ") };
}
